export class NavItemEntity {
    name;
    link;
    icon;
    activeIcon;
    isActive;
  
    constructor(name = "", link = "", icon="", activeIcon="", isActive=false) {
      this.name = name;
      this.link = link;
      this.icon = icon;
      this.activeIcon = activeIcon;
      this.isActive = isActive;
    }
  }
  